export const CANCEL_SALE = {
    headerText: "Sale Cancelled",
    bodyText: "The sale has been cancelled."
}

export const REQUEST_INFORMATION = {
    headerText: "Requested More Information",
    bodyText: "You have requested more information.",
}

export const DECLINE_CLAIM = {
    headerText: "Claim Declined",
    bodyText: "You have declined the claim.",
}

export const REVIEW_COMPLETE = {
    headerText: "Review Complete",
    bodyText: "The claim review has been completed.",
}

export const MAKE_OFFER = {
    headerText: "Offer Made",
    bodyText: "The offer has successfully been made.",
  };

  export const CALLBACK_REQUEST = {
    headerText: "Callback Completed",
    bodyText: "The callback request has been completed.",
  };

  export const COMPLETE_CLAIM = {
    headerText: "Claim Completed",
    bodyText: "The claim has been completed.",
  };